import React from 'react';
import {
  Heading,
  LinkButton,
  LinksContainer,
  Main,
  SectionLeft,
  SectionRight,
  SubHeading,
} from './success.style';
import { useNavigate } from 'react-router-dom';
import { SuccessIcon } from '../../../icons';

import backgroundImg from '../../../assets/PNG/success-page.png';
import backgroundImgCompress from '../../../assets/PNG/success-page-compress.png';
import useImageLoader from '../../../hooks/useImageLoader';
import { IntlMessages } from '../../../helper/langHelper';

const SuccessPage = () => {
  const navigate = useNavigate();
  const successPageBg = useImageLoader(backgroundImgCompress, backgroundImg);

  const handleClick = () => {
    navigate('/');
  };
  return (
    <Main>
      <SectionLeft>
        <SuccessIcon />
        <Heading>
          <IntlMessages id="success.heading" />
        </Heading>
        <SubHeading>
          <IntlMessages id="success.subheading" />
        </SubHeading>
        <LinksContainer>
          <LinkButton onClick={handleClick}>
            <IntlMessages id="button.back.dashboard" />
          </LinkButton>
        </LinksContainer>
      </SectionLeft>
      <SectionRight bg={successPageBg} />
    </Main>
  );
};

export default SuccessPage;
